import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CircleCheck = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color}
          d="M8 13.75C11.1756 13.75 13.75 11.1756 13.75 8C13.75 4.82436 11.1756 2.25 8 2.25C4.82436 2.25 2.25 4.82436 2.25 8C2.25 11.1756 4.82436 13.75 8 13.75ZM10.9496 5.92675C11.0989 5.69448 11.0317 5.38511 10.7994 5.23576C10.5672 5.0864 10.2578 5.15361 10.1085 5.38588L7.44818 9.52288L5.84245 7.74091C5.6576 7.53577 5.34145 7.51932 5.1363 7.70418C4.93116 7.88903 4.91471 8.20519 5.09957 8.41033L7.14335 10.6784C7.24765 10.7942 7.39994 10.8547 7.55524 10.8421C7.71054 10.8295 7.85108 10.7452 7.93535 10.6142L10.9496 5.92675Z"
        />
      </svg>
    )
  },
)

export default CircleCheck
